import request from "./request"

/**
 * 上传用户媒体，文件由服务端按场景校验并返回站内资源地址。
 */
export function uploadMedia(file, scene, onProgress) {
  const data = new FormData()
  data.append("scene", scene)
  data.append("file", file)

  return request({
    url: "/upload/media",
    method: "post",
    data,
    timeout: 120000,
    onUploadProgress: event => {
      if (!onProgress || !event.total) return
      onProgress(Math.min(100, Math.round(event.loaded / event.total * 100)))
    }
  })
}
